module.exports = __webpack_public_path__ + "media/images/sprites/flag-64d419e5a8a6923e3700602c7b3fca65.png";